module.exports = __webpack_public_path__ + "img/NO937902263.8c0f56f0.png";